document.addEventListener("DOMContentLoaded", function () {
const content = document.querySelector("#article-content");
const toc = document.querySelector("#toc");

if (!content || !toc) return;

const headings = content.querySelectorAll("h2");

headings.forEach((h2, index) => {
    const id = "section-" + index;
    h2.setAttribute("id", id);

    const link = document.createElement("a");
    link.href = "#" + id;
    link.textContent = h2.textContent;

    toc.appendChild(link);
});

// Smooth Scroll
document.querySelectorAll('#toc a').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
    e.preventDefault();
    document.querySelector(this.getAttribute('href')).scrollIntoView({
        behavior: 'smooth'
    });
    });
});
});



document.addEventListener("DOMContentLoaded", function () {
  const tocLinks = document.querySelectorAll("#toc a");
  const sections = [...tocLinks].map(link => {
    return document.querySelector(link.getAttribute("href"));
  });

  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        const id = entry.target.getAttribute("id");

        if (entry.isIntersecting) {
          tocLinks.forEach(link => {
            link.classList.toggle("active", link.getAttribute("href") === "#" + id);
          });
        }
      });
    },
    {
      rootMargin: "-40% 0px -50% 0px",
      threshold: 0
    }
  );

  sections.forEach(section => observer.observe(section));
});

